import {Injectable, Type} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Step11CompanyInformationComponent} from './chapter/chapter-1-project-setup/step-1-1-company-information/step-1-1-company-information.component';
import {Step13ProjectSettingsComponent} from './chapter/chapter-1-project-setup/step-1-3-project-settings/step-1-3-project-settings.component';
import {Step21DesignCriteriaComponent} from './chapter/chapter-2-principle-definiton/step-2-1-design-criteria/step-2-1-design-criteria.component';
import {Step22ArchitecturalPrinciplesComponent} from './chapter/chapter-2-principle-definiton/step-2-2-architectural-principles/step-2-2-architectural-principles.component';
import {PageMapping} from '../../../shared/model/page-tree.types';
import {Step12ProjectCharterComponent} from './chapter/chapter-1-project-setup/step-1-2-project-charter/step-1-2-project-charter.component';
import {Step52RfiInvitationPreviewComponent} from './chapter/chapter-5-rfi/step-5-2-invitation-preview/step-5-2-rfi-invitation-preview.component';
import {Step51RfiSubCriteriaEvaluationComponent} from './chapter/chapter-5-rfi/step-5-1-rfi-subcriteria-evaluation/step-5-1-rfi-subcriteria-evaluation.component';
import {Step53RfiInvitationListComponent} from './chapter/chapter-5-rfi/step-5-3-rfi-invitation-list/step-5-3-rfi-invitation-list.component';
import {Step61EvaluationCriteriaComparisonComponent} from './chapter/chapter-6-proposal-evaluation/step-6-1-evaluation-criteria-comparison/step-6-1-evaluation-criteria-comparison.component';
import {Step62RfpInvitationPreviewComponent} from './chapter/chapter-6-proposal-evaluation/step-6-2-rfp-invitation-preview/step-6-2-rfp-invitation-preview.component';
import {Step63RfpInvitationListComponent} from './chapter/chapter-6-proposal-evaluation/step-6-3-rfp-invitation-list/step-6-3-rfp-invitation-list.component';
import {Step54ProviderResultsComponent} from './chapter/chapter-5-rfi/step-5-4-provider-results/step-5-4-provider-results.component';
import {Chapter, StepStatus} from './project-step.types';
import {ProjectStepComponentInterface} from './project-base-step/project-base-step.component';
import {Step64ProviderResultsComponent} from './chapter/chapter-6-proposal-evaluation/step-6-4-provider-results/step-6-4-provider-results.component';
import {Step31SystemRecordingComponent} from './chapter/chapter-3-system-capture/step-3-1-system-recording/step-3-1-system-recording.component';
import {Step32SystemFlowComponent} from './chapter/chapter-3-system-capture/step-3-2-system-flow/step-3-2-system-flow.component';
import {Step71DemonstrationAgendaComponent} from './chapter/chapter-7-rfd/step-7-1-demonstration-agenda/step-7-1-demonstration-agenda.component';
import {Step72UseCasesComponent} from './chapter/chapter-7-rfd/step-7-2-use-cases/step-7-2-use-cases.component';
import {Step73InvitationPreviewComponent} from './chapter/chapter-7-rfd/step-7-3-invitation-preview/step-7-3-invitation-preview.component';
import {Step75ProviderEvaluationComponent} from './chapter/chapter-7-rfd/step-7-5-provider-evaluation/step-7-5-provider-evaluation.component';
import {Step76ProviderResultsComponent} from './chapter/chapter-7-rfd/step-7-6-provider-results/step-7-6-provider-results.component';
import {Step81RfqProposalParameterComponent} from './chapter/chapter-8-rfq/step-8-1-proposal-parameter/step-8-1-rfq-proposal-parameter.component';
import {ProjectChapterType, ProjectStepType} from '@frontend/shared';
import {Step82InvitationPreviewComponent} from './chapter/chapter-8-rfq/step-8-2-invitation-preview/step-8-2-invitation-preview.component';
import {Step74InvitationListComponent} from './chapter/chapter-7-rfd/step-7-4-invitation-list/step-7-4-invitation-list.component';
import {Step83InvitationListComponent} from './chapter/chapter-8-rfq/step-8-3-invitation-list/step-8-3-invitation-list.component';
import {Step84ProviderResultsComponent} from './chapter/chapter-8-rfq/step-8-4-provider-results/step-8-4-provider-results.component';
import {Step85ProviderResultsComponent} from './chapter/chapter-8-rfq/step-8-5-provider-results/step-8-5-provider-results.component';
import {Step91OverallResultsOverviewComponent} from './chapter/chapter-9-overall-result/step-9-1-overall-results-overview/step-9-1-overall-results-overview.component';
import {Step92ProjectDecisionPreviewComponent} from './chapter/chapter-9-overall-result/step-9-2-project-decition/step-9-2-project-decision-preview.component';
import {Step101DecisionReportComponent} from './chapter/chapter-10-decision-report/step-10-1-decision-report/step-10-1-decision-report.component';
import {Step41EvaluationCriteriaXComponent} from './chapter/chapter-4-evaluation-criteria-x/step-4-1-evaluation-criteria-x/step-4-1-evaluation-criteria-x.component';
import {Step42SubCriteriaEvaluationXComponent} from './chapter/chapter-4-evaluation-criteria-x/step-4-2-sub-criteria-evaluation-x/step-4-2-sub-criteria-evaluation-x.component';
import {Step43CriteriaWeightsOverviewComponent} from './chapter/chapter-4-evaluation-criteria-x/step-4-3-criteria-weights-overview/step-4-3-criteria-weights-overview.component';

export interface StepConfig {
  id: ProjectStepType;
  content: Type<ProjectStepComponentInterface>;
  status?: StepStatus;
}

export interface ChapterConfig {
  id: ProjectChapterType;
  icon: string;
  expanded: boolean;
  steps: StepConfig[];
}

export const DEFAULT_CHAPTER_ICON = 'pi pi-book';

export const CHAPTER_CONFIGS: ChapterConfig[] = [
  {
    id: ProjectChapterType.PROJECT_SETUP,
    icon: 'pi pi-map',
    expanded: true,
    steps: [
      {
        id: ProjectStepType.COMPANY_INFORMATION,
        content: Step11CompanyInformationComponent,
      },
      {
        id: ProjectStepType.PROJECT_CHARTER,
        content: Step12ProjectCharterComponent,
      },
      {
        id: ProjectStepType.PROJECT_SETTINGS,
        content: Step13ProjectSettingsComponent,
      },
    ],
  },
  {
    id: ProjectChapterType.PRINCIPLE_DEFINITION,
    icon: 'pi pi-compass',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.DESIGN_CRITERIA,
        content: Step21DesignCriteriaComponent,
      },
      {
        id: ProjectStepType.ARCHITECTURAL_PRINCIPLES,
        content: Step22ArchitecturalPrinciplesComponent,
      },
    ],
  },
  {
    id: ProjectChapterType.ACTUAL_SYSTEMS,
    icon: 'pi pi-desktop',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.SYSTEM_RECORDING,
        content: Step31SystemRecordingComponent,
      },
      {
        id: ProjectStepType.SYSTEM_INTEGRATION_CONFIG,
        content: Step32SystemFlowComponent,
      },
    ],
  },
  {
    id: ProjectChapterType.EVALUATION_CRITERIA,
    icon: 'pi pi-check-circle',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.EVALUATION_CRITERIA,
        content: Step41EvaluationCriteriaXComponent,
      },
      {
        id: ProjectStepType.EVALUATION_SUB_CRITERIA,
        content: Step42SubCriteriaEvaluationXComponent,
      },
      {
        id: ProjectStepType.EVALUATION_CRITERIA_OVERVIEW,
        content: Step43CriteriaWeightsOverviewComponent,
      },
    ],
  },
  // Remove if all is fine with the new component.
  // {
  //   id: ProjectChapterType.EVALUATION_CRITERIA_X,
  //   icon: 'pi pi-check-circle',
  //   expanded: false,
  //   steps: [
  //     {
  //       id: ProjectStepType.EVALUATION_CRITERIA_X,
  //       content: Step41EvaluationCriteriaComponent,
  //     },
  //     {
  //       id: ProjectStepType.EVALUATION_SUB_CRITERIA_X,
  //       content: Step42SubCriteriaEvaluationComponent,
  //     },
  //   ],
  // },
  {
    id: ProjectChapterType.RFI,
    icon: 'pi pi-search',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.RFI_EVALUATION_SUBCRITERIA,
        content: Step51RfiSubCriteriaEvaluationComponent,
      },
      {
        id: ProjectStepType.RFI_INVITATION_PREVIEW,
        content: Step52RfiInvitationPreviewComponent,
      },
      {
        id: ProjectStepType.RFI_INVITATION_LIST,
        content: Step53RfiInvitationListComponent,
      },
      {
        id: ProjectStepType.RFI_PROVIDER_RESULTS,
        content: Step54ProviderResultsComponent,
      },
    ],
  },
  {
    id: ProjectChapterType.RFP,
    icon: 'pi pi-chart-bar',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.RFP_EVALUATION_SUBCRITERIA,
        content: Step61EvaluationCriteriaComparisonComponent,
      },
      {
        id: ProjectStepType.RFP_INVITATION_PREVIEW,
        content: Step62RfpInvitationPreviewComponent,
      },
      {
        id: ProjectStepType.RFP_INVITATION_LIST,
        content: Step63RfpInvitationListComponent,
      },
      {
        id: ProjectStepType.RFP_PROVIDER_RESULTS,
        content: Step64ProviderResultsComponent,
      },
    ],
  },
  {
    id: ProjectChapterType.RFD,
    icon: 'pi pi-video',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.RFD_DEMONSTRATION_AGENDA,
        content: Step71DemonstrationAgendaComponent,
      },
      {
        id: ProjectStepType.RFD_DEMONSTRATION_USE_CASES,
        content: Step72UseCasesComponent,
      },
      {
        id: ProjectStepType.RFD_INVITATION_PREVIEW,
        content: Step73InvitationPreviewComponent,
      },
      {
        id: ProjectStepType.RFD_INVITATION_LIST,
        content: Step74InvitationListComponent,
      },
      {
        id: ProjectStepType.RFD_PROVIDER_EVALUATION,
        content: Step75ProviderEvaluationComponent,
      },
      {
        id: ProjectStepType.RFD_PROVIDER_RESULTS,
        content: Step76ProviderResultsComponent,
      },
    ],
  },
  {
    id: ProjectChapterType.RFQ,
    icon: 'pi pi-euro',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.RFQ_PROPOSAL_PARAMETER,
        content: Step81RfqProposalParameterComponent,
      },
      {
        id: ProjectStepType.RFQ_INVITATION_PREVIEW,
        content: Step82InvitationPreviewComponent,
      },
      {
        id: ProjectStepType.RFQ_PROVIDER_INVITATION,
        content: Step83InvitationListComponent,
      },
      {
        id: ProjectStepType.RFQ_RESULTS,
        content: Step84ProviderResultsComponent,
      },
      {
        id: ProjectStepType.RFQ_AGGREGATED_RESULTS,
        content: Step85ProviderResultsComponent,
      },
    ],
  },
  {
    id: ProjectChapterType.OVERALL_RESULT,
    icon: 'pi pi-flag',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.OVERALL_RESULTS_OVERVIEW,
        content: Step91OverallResultsOverviewComponent,
      },
      {
        id: ProjectStepType.OVERALL_RESULTS_DECISION,
        content: Step92ProjectDecisionPreviewComponent,
      },
    ],
  },
  {
    id: ProjectChapterType.DECISION_REPORT,
    icon: 'pi pi-flag',
    expanded: false,
    steps: [
      {
        id: ProjectStepType.DECISION_REPORT_OVERVIEW,
        content: Step101DecisionReportComponent,
      },
    ],
  },
];

export function getChaptersFromConfig(
  configs: ChapterConfig[],
  defaultStatus = StepStatus.NOT_STARTED,
): Chapter[] {
  return configs.map((chapter, chapterIndex) => ({
    ...chapter,
    configId: chapter.id,
    chapterUiNumber: chapterIndex + 1,
    steps: chapter.steps.map((step, stepIndex) => ({
      ...step,
      configId: step.id,
      stepUiNumber: stepIndex + 1,
      status: step.status ?? defaultStatus,
      parentChapterConfigId: chapter.id,
    })),
  }));
}

@Injectable({
  providedIn: 'root',
})
export class ChapterConfigService {
  loadChapterDefinitions(): Observable<ChapterConfig[]> {
    return of(CHAPTER_CONFIGS);
  }

  createPageMappingsFromChapters(chapters: ChapterConfig[]): PageMapping[] {
    return chapters.map((chapter) => {
      const mapping: PageMapping = {
        key: `page${chapter.id}`,
        label: '',
        subpages: chapter.steps.map((step) => step.id),
      };

      return mapping;
    });
  }
}
